import { useState, useEffect } from 'react';
import { Container, Box, Stack, Grid, Typography, TextField, Tooltip, Stepper, Step, StepLabel } from '@mui/material';
import { Button, Alert, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Card, CardContent, CardActions, IconButton, Badge } from '@mui/material';
import { List, ListItem, ListItemButton, ListItemText, ListItemIcon, ListItemAvatar, Avatar, Select, MenuItem, InputLabel, FormControl, Input } from '@mui/material';

import { format } from 'date-fns';

import { pb } from '../utilities/pocketbase';

import Payment from './Payment';

import CheckIcon from '@mui/icons-material/Check';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorIcon from '@mui/icons-material/Error';
import PaidIcon from '@mui/icons-material/Paid';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import PaymentIcon from '@mui/icons-material/Payment';
import DownloadIcon from '@mui/icons-material/Download';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

// const CLASS_OPTIONS = ["VIII", "IX", "X", "XI", "XII", "UG", "PG", "ABOVE PG"]
const CLASS_OPTIONS = ["VIII", "IX", "X", "XI", "XII", "UG",]
const REGISTER_STEPS = ['Register examinee', 'Payment'];

export default function Register() {
    const [userData, setUserData] = useState({
        firstname: "",
        lastname: "",
        email: "",
        mobile: "",
        yob: "",
    })
    const [registeredData, setRegisteredData] = useState({
        id: "",
        email: "",
        firstname: "",
        lastname: "",
        autoFilled: false,
    })
    const [registeredInfo, setRegisteredInfo] = useState({ autoFilled: false })
    const [dp, setDp] = useState()
    const [exams, setExams] = useState([])
    const [selectedExam, setSelectedExam] = useState("");
    const [selectedStudyClass, setSelectedStudyClass] = useState("")
    const [success, setSuccess] = useState("")
    const [error, setError] = useState("")
    const [sendRequest, setSendRequest] = useState(false)
    const [activeStep, setActiveStep] = useState(0);
    const [skipped, setSkipped] = useState(new Set());
    const [isValidRegistrationId, setIsValidRegistrationId] = useState(false)
    const [isValidPaidRegistrationId, setIsValidPaidRegistrationId] = useState(false)
    const [downloadLink, setDownloadLink] = useState("");

    const isStepOptional = (step) => {
        return step === -1;
    };

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const handleNext = () => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleSkip = () => {
        if (!isStepOptional(activeStep)) {
            throw new Error("You can't skip a step that isn't optional.");
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped((prevSkipped) => {
            const newSkipped = new Set(prevSkipped.values());
            newSkipped.add(activeStep);
            return newSkipped;
        });
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    const handleExams = (event, index, examId) => {
        setSelectedExam(examId);
    };

    const handleClassChange = (e) => {
        console.log(e.target.value)
        setSelectedStudyClass(e.target.value)
        setSelectedExam("")
    }

    useEffect(() => {
        window.document.title = 'Registration'
        pb.collection('exams').getFullList({
            sort: 'starts',
        }).then(_exams => {
            setExams(_exams)
            // console.log("exams: ", _exams)
        }).catch(error => {
            console.log("exams error: ", error)
            // setError(error?.message)
        })

        return () => { window.document.title = process.env.REACT_APP_NAME }
    }, [])

    useEffect(() => {
        if (sendRequest && userData.firstname && userData.email && userData.mobile && selectedExam && selectedStudyClass && userData.yob) {
            setError("")
            setSuccess("")
            const data = new FormData()
            for (const key of Object.keys(userData)) {
                data.append(key, userData[key])
            }
            dp && data.append("avatar", dp)
            selectedExam && data.append("exam", selectedExam)
            selectedStudyClass && data.append("class", selectedStudyClass)
            pb.collection('profiles')
                .create(data)
                // .create({ ...userData, exam: selectedExam, class: selectedStudyClass })
                .then(profile => {
                    setSendRequest(false)
                    setError("")
                    // console.log("profile: %O", profile)
                    if (profile?.id) {
                        try {
                            const minProfile = {
                                "registrationid": profile?.id,
                                "firstname": profile?.firstname,
                                "lastname": profile?.lastname,
                                "yob": profile?.yob,
                                "email": profile?.email,
                                "mobile": profile?.mobile,
                                "class": profile?.class,
                                "created": profile?.created,
                            }

                            const minProfileString = `
registrationid : ${profile?.id},
firstname      : ${profile?.firstname},
lastname       : ${profile?.lastname},
yob            : ${profile?.yob},
email          : ${profile?.email},
mobile         : ${profile?.mobile},
class          : ${profile?.class},
created        : ${profile?.created},
`
                            const json = JSON.stringify(minProfile, null, 2);
                            const blob = new Blob([json], { type: "application/json" });
                            const blobTxt = new Blob([minProfileString], { type: "application/text" });
                            const href = URL.createObjectURL(blobTxt);
                            const aLink = document.createElement("a")
                            aLink.href = href
                            aLink.download = `${profile?.id + " - "}RegistrationDetails.txt`
                            aLink.click()
                            setDownloadLink(href)
                        } catch (e) {
                            console.log("JSON Stringify failed!", e)
                        }
                    }
                    setSuccess("Successfully Registered. The registration details has been sent to your email address. Download your registration details for reference.")
                    setUserData({
                        firstname: "",
                        lastname: "",
                        email: "",
                        mobile: "",
                        yob: "",
                    })
                    setSelectedExam("")
                    setSelectedStudyClass("")
                    if (window.localStorage) {
                        window.localStorage.setItem("registrationInfo", JSON.stringify(profile))
                    }
                    setRegisteredData(ps => ({
                        ...ps,
                        id: profile?.id,
                        email: profile?.email,
                        firstname: profile?.firstname,
                        lastname: profile?.lastname,
                        autoFilled: true
                    }))
                    setActiveStep(1)
                }).catch(error => {
                    setSendRequest(false)
                    console.log("error: ", error, error?.data)
                    if (error?.data?.data?.email?.code === 'validation_not_unique') {
                        setError({ message: "email already registered!" })
                    }
                    else {
                        setError(error)
                    }
                }).finally(() => {
                    setSendRequest(false)
                })
        }

        setSendRequest(false)
    }, [sendRequest, dp, userData, selectedExam, selectedStudyClass])

    useEffect(() => {
        if (window.localStorage) {
            const regInfo = window.localStorage.getItem("registrationInfo")
            if (regInfo) {
                try {
                    const regInfoObj = JSON.parse(regInfo)
                    // console.log("regInfo: ", regInfoObj)
                    if (regInfoObj?.id && regInfoObj?.email) {
                        setRegisteredData(ps => ({
                            ...ps,
                            id: regInfoObj?.id,
                            // email: regInfoObj?.email,
                            firstname: regInfoObj?.firstname,
                            lastname: regInfoObj?.lastname,
                            autoFilled: true
                        }))
                        pb.collection('readonly_profileids').getOne(`${regInfoObj?.id}`).then(profileDetails => {
                            profileDetails?.id && profileDetails?.id === regInfoObj?.id && setIsValidRegistrationId(true)
                            pb.collection('readonly_paid_profileids').getOne(`${regInfoObj?.id}`, { expand: "profile" }).then(paidProfile => {
                                // console.log("paidProfile: ", paidProfile)
                                if (paidProfile?.id && paidProfile?.id.length === 15) {
                                    setIsValidPaidRegistrationId(true)
                                    setActiveStep(2)
                                }
                                else {
                                    setIsValidPaidRegistrationId(false)
                                }
                            }).catch(error => {
                                console.log("paidProfileDetails checking failed!", error)
                                setIsValidPaidRegistrationId(false)
                            })
                        }).catch(error => {
                            console.log("profile checking failed!", error)
                        })
                    }
                    setRegisteredInfo(regInfoObj)
                } catch (e) {
                    console.log(e)
                }
            }
        }
    }, [success])

    const handleRegistrationId = (e) => {
        e.target.value.length <= 15 && setRegisteredData(ps => ({ ...ps, id: e.target.value }))
        if (e.target.value.length === 15) {
            pb.collection('readonly_profileids').getOne(`${e.target.value}`).then(record => {
                // console.log("profile: ", record)
                record?.id && record?.id === e.target.value && setIsValidRegistrationId(true)
                pb.collection('readonly_paid_profileids').getOne(`${e.target.value}`, { expand: "profile" }).then(paidProfile => {
                    // console.log("paidProfile: ", paidProfile)
                    if (paidProfile?.id && paidProfile?.id.length === 15) {
                        setIsValidPaidRegistrationId(true)
                        setActiveStep(2)
                    }
                    else {
                        setIsValidPaidRegistrationId(false)
                    }
                }).catch(error => {
                    console.log("paidProfileDetails checking failed!", error)
                    setIsValidPaidRegistrationId(false)
                })
            }).catch(error => {
                console.log("profile checking failed!", error)
                setIsValidRegistrationId(false)
            })
        } else {
            setIsValidRegistrationId(false)
        }
    }

    return (
        <Container maxWidth={"md"} sx={{ py: 2 }}>
            <Card sx={{ borderRadius: 3, boxShadow: 5 }} variant='outlined'>
                <Typography variant='h6' sx={{ mx: 2, mt: 2 }}>Registration form</Typography>
                <CardContent>
                    {activeStep === 0 && <Box>
                        <Button startIcon={<ArrowBackRoundedIcon />} component={RouterLink} to="/" sx={{ borderRadius: 5, px: 2 }}>Back to home</Button>
                    </Box>}
                    <Stepper activeStep={activeStep} sx={{ my: 2, pl: 1 }}>
                        {REGISTER_STEPS.map((label, index) => {
                            const stepProps = {};
                            const labelProps = {};
                            if (isStepOptional(index)) {
                                labelProps.optional = (
                                    <Typography variant="caption">Optional</Typography>
                                );
                            }
                            if (isStepSkipped(index)) {
                                stepProps.completed = false;
                            }
                            return (
                                <Step key={label} {...stepProps}>
                                    <StepLabel {...labelProps}>{label}</StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                    <Stack spacing={1} sx={{ my: 1 }}>
                        <Alert icon={false} severity='warning' sx={{ p: 2, border: 1, borderRadius: 3, borderColor: "divider", maxWidth: "md" }}>
                            If you have already registered, proceed directly to the payment section and make the payment using your registration ID.
                            {activeStep === 0 && <Button startIcon={<PaymentIcon />} onClick={handleNext} color='warning' size="large" sx={{ borderRadius: 5, mt: 1 }} fullWidth>
                                Go to Payment
                            </Button>}
                        </Alert>
                    </Stack>
                    {activeStep === REGISTER_STEPS.length && (
                        <Stack spacing={1}>
                            <Alert severity='info' icon={false} sx={{ p: 2, border: 1, borderRadius: 3, borderColor: "divider", maxWidth: "md", justifyContent: "center" }}>
                                <Typography variant='h6' align='center'>
                                    All steps for the registration are completed.
                                </Typography>
                                <Typography variant='h6' align='center'>
                                    {/* Please check your email for the exam login credentials. */}
                                    The login credentials will be send to your email before the exam.
                                </Typography>
                            </Alert>
                            <Alert severity='warning' sx={{ p: 2, border: 1, borderRadius: 3, borderColor: "divider", maxWidth: "md" }}>
                                The examination must be taken exclusively through the use of a desktop/laptop.
                            </Alert>
                        </Stack>
                    )}
                    {activeStep === 0 && <Stack spacing={2}>
                        <Stack justifyContent={"center"} alignItems={"center"}>
                            <Box sx={{ py: 1 }}>
                                <Badge
                                    overlap="circular"
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                    badgeContent={<UploadImage id={"dp"} setPhoto={setDp} />}
                                >
                                    <Avatar sx={{ height: "8rem", width: "8rem" }} alt={userData.firstname.split()[0]} src={dp ? URL.createObjectURL(dp) : ""} />
                                </Badge>
                            </Box>
                        </Stack>
                        <Grid container gap={2} justifyContent={"center"} alignItems={"center"}>
                            <Grid item xs={12} sm={12} md={5} lg={5}>
                                <TextField required fullWidth value={userData.firstname} onChange={(e) => setUserData(ps => ({ ...ps, firstname: e.target.value }))} label={"firstname"} error={error?.data?.data?.firstname} helperText={error?.data?.data?.firstname?.message} />
                            </Grid>

                            <Grid item xs={12} sm={12} md={5} lg={5}>
                                <TextField fullWidth value={userData.lastname} helperText={error?.data?.data?.lastname?.message} onChange={(e) => setUserData(ps => ({ ...ps, lastname: e.target.value }))} label={"lastname"} error={error?.data?.data?.lastname} />
                            </Grid>

                            <Grid item xs={12} sm={12} md={5} lg={5}>
                                <TextField required fullWidth value={userData.email} onChange={(e) => setUserData(ps => ({ ...ps, email: e.target.value }))} label={"email"} error={error?.data?.data?.email} helperText={error?.data?.data?.email?.message} />
                            </Grid>

                            <Grid item xs={12} sm={12} md={5} lg={5}>
                                <TextField required fullWidth value={userData.mobile} onChange={(e) => setUserData(ps => ({ ...ps, mobile: e.target.value }))} label={"mobile"} error={error?.data?.data?.mobile} helperText={error?.data?.data?.firstname?.mobile} />
                            </Grid>

                            <Grid item xs={12} sm={12} md={5} lg={5}>
                                <TextField required fullWidth value={userData.yob} type='number' onChange={(e) => setUserData(ps => ({ ...ps, yob: e.target.value }))} label={"year of birth"} error={error?.data?.data?.yob} helperText={error?.data?.data?.yob?.message} />
                            </Grid>

                            <Grid item xs={12} sm={12} md={5} lg={5}>
                                <FormControl fullWidth>
                                    <InputLabel required>class</InputLabel>
                                    <Select
                                        required
                                        value={selectedStudyClass}
                                        label="class"
                                        onChange={handleClassChange}
                                    >
                                        <MenuItem value={""}>{"None"}</MenuItem>
                                        {CLASS_OPTIONS && CLASS_OPTIONS.length > 0 && CLASS_OPTIONS.map((x, index) => <MenuItem key={x} value={x}>{x}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        {selectedStudyClass && exams?.length > 0 && <Typography align='center' variant='subtitle1' fontWeight={"bold"}>Choose your date</Typography>}

                        {selectedStudyClass && exams?.length > 0 && <List>
                            {exams
                                .filter(x => x?.id && x?.level && x?.registrationopen && x)
                                .filter(x => CLASS_OPTIONS.slice(0, 3).includes(selectedStudyClass) && x.level === "1" && x)
                                .map((exam, index) => (<ListItemButton key={exam.id} sx={{ border: 1, borderRadius: 2, borderColor: "divider", mb: 1 }} onClick={(event) => handleExams(event, index, exam?.id)} selected={exam?.id === selectedExam}>
                                    <ListItemIcon>
                                        {exam?.id === selectedExam ? <RadioButtonCheckedIcon color='info' /> : <RadioButtonUncheckedIcon color='info' />}
                                    </ListItemIcon>
                                    <ListItemText secondary={`${exam?.name} • Level ${exam.level}`} primary={`${exam.starts && format(new Date(exam.starts), 'PPPpp')} to ${exam.ends && format(new Date(exam.ends), 'pp')}`} />
                                </ListItemButton>))}
                            {exams
                                .filter(x => x?.id && x?.level && x?.registrationopen && x)
                                .filter(x => CLASS_OPTIONS.slice(3).includes(selectedStudyClass) && x.level === "2" && x)
                                .map((exam, index) => (<ListItemButton key={exam.id} sx={{ border: 1, borderRadius: 2, borderColor: "divider", mb: 1 }} onClick={(event) => handleExams(event, index, exam?.id)} selected={exam?.id === selectedExam}>
                                    <ListItemIcon>
                                        {exam?.id === selectedExam ? <RadioButtonCheckedIcon color='info' /> : <RadioButtonUncheckedIcon color='info' />}
                                    </ListItemIcon>
                                    <ListItemText secondary={`${exam?.name} • Level ${exam.level}`} primary={`${exam.starts && format(new Date(exam.starts), 'PPPpp')} to ${exam.ends && format(new Date(exam.ends), 'pp')}`} />
                                </ListItemButton>))}
                        </List>}
                        <Stack spacing={1}>
                            <Button startIcon={<AppRegistrationIcon />} onClick={() => setSendRequest(true)} variant="contained" size="large" sx={{ py: 2 }} color='info' disabled={!(userData.firstname.length >= 3 && userData.email && userData.mobile.length >= 10 && selectedExam && selectedStudyClass && userData.yob)} fullWidth>Register</Button>
                        </Stack>
                    </Stack>}
                    {activeStep === 1 && <Stack spacing={2} sx={{ py: 2 }}>
                        {isValidRegistrationId && registeredData?.id && <Typography align='center' variant='h5'>Registration ID : {registeredData?.id}</Typography>}
                        <Grid container gap={2} justifyContent={"center"} alignItems={"center"}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <TextField required fullWidth value={registeredData.id} onChange={handleRegistrationId} label={"registration id"}
                                    // disabled={registeredData?.autoFilled}
                                    error={error?.data?.data?.id} color={isValidRegistrationId ? "success" : ""} InputProps={{
                                        endAdornment: (
                                            <Stack direction={"row"} spacing={1}>
                                                {isValidRegistrationId ? <Tooltip title="valid registration id"><CheckIcon color='success' /></Tooltip> : registeredData?.id.length === 15 && <Tooltip title="invalid registration id"><ErrorIcon color='error' /></Tooltip>}
                                                {isValidPaidRegistrationId ? <Tooltip title="paid"><PaidIcon color='warning' /></Tooltip> : registeredData?.id.length === 15 && <Tooltip title="unpaid"><WarningAmberIcon color='warning' /></Tooltip>}
                                            </Stack>
                                        )
                                    }} />
                            </Grid>
                        </Grid>
                        {/* {isValidRegistrationId && <Typography align='center' variant='h5' fontWeight={"light"}>
                            {[registeredData?.firstname, registeredData?.lastname].join(" ")}
                        </Typography>} */}
                        {isValidPaidRegistrationId && <Alert icon={<PaidIcon />} severity='warning' sx={{ justifyContent: "center", alignItems: "center", border: 1 }}>
                            Already paid for this registration id!
                        </Alert>}
                    </Stack>}
                    <Stack sx={{ my: 1 }} spacing={1}>
                        {downloadLink && <Button startIcon={<DownloadIcon />} component={Link} download={`RegistrationDetails.txt`} href={downloadLink} color='warning' sx={{ textTransform: "none" }}>Download Registration Details</Button>}
                        {error?.message && <Alert severity='error' sx={{ justifyContent: "center", alignItems: "center", border: 1 }}>{error?.message}</Alert>}
                        {success && <Alert severity='success' sx={{ justifyContent: "center", alignItems: "center", border: 1 }}>{success}</Alert>}
                    </Stack>
                </CardContent>
                <CardActions>
                    {activeStep === REGISTER_STEPS.length ? <Button onClick={handleReset} size="large" sx={{ py: 2 }} fullWidth>GO BACK</Button> :
                        <>
                            <Button
                                startIcon={<AppRegistrationIcon />}
                                color="inherit"
                                disabled={activeStep === 0}
                                onClick={handleBack}
                                size="large" sx={{ py: 2 }} fullWidth
                            >
                                Registration
                            </Button>

                            {isStepOptional(activeStep) && (
                                <Button color="inherit" onClick={handleSkip} size="large" sx={{ py: 2 }} fullWidth>
                                    Skip
                                </Button>
                            )}

                            {activeStep === 0 && <Button startIcon={<PaymentIcon />} onClick={handleNext} color='warning' size="large" sx={{ py: 2 }} fullWidth>
                                Go to Payment
                                {/* {activeStep === REGISTER_STEPS.length - 1 ? 'Finish' : 'Payment'} */}
                            </Button>}
                        </>}
                    {/* {activeStep === 1 && <Button id="btnSubmit" startIcon={<PaymentIcon />} disabled={!isValidRegistrationId || isValidPaidRegistrationId}
                        onClick={(e) => { }}
                        variant="contained" size="large" color='warning' sx={{ py: 2 }} fullWidth>Pay</Button>} */}
                    {activeStep === 1 && <Payment disabled={!isValidRegistrationId || isValidPaidRegistrationId} registrationId={registeredData?.id} setActiveStep={setActiveStep} setSuccess={setSuccess} />}
                </CardActions>
                <Alert icon={false} severity='info' sx={{ p: 2, border: 1, borderRadius: 3, borderColor: "divider", alignItems: "center", maxWidth: "md", m: 1 }}>
                    <ListItem key={"info1"} divider>
                        <ListItemAvatar>
                            <Avatar sx={{ background: "transparent" }}>
                                <WarningAmberOutlinedIcon color='warning' />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={<Typography>Please, check your spam folder in mail. Emails are sent through <Link sx={{ textDecoration: "none" }} href="mailto:noreply@crraoaimscs.ac.in">noreply@crraoaimscs.ac.in</Link>. Report the mail as NOT spam so that you receive our future mails directly in your Inbox. Keep checking this website for updated information. Send your queries to <Link sx={{ textDecoration: "none" }} href="mailto:support@crraoaimscs.ac.in">support@crraoaimscs.ac.in</Link>.</Typography>} />
                    </ListItem>
                </Alert>
            </Card>
        </Container >
    )
}

function UploadImage({ id, setPhoto }) {
    const handelPhotoUpload = (e) => {
        var file = e.target.files[0];
        setPhoto(file)
    }

    return (
        <label htmlFor={id}>
            <Input id={id} accept='image/png, image/jpeg, image/bmp, image.gif, image/jpg' type="file" onChange={handelPhotoUpload}
                style={{ width: '0px', visibility: 'hidden' }} />
            <Tooltip title="Upload DP" placement="bottom"><IconButton size='small' color="warning" component="span">
                <AddPhotoAlternateIcon />
            </IconButton></Tooltip>
        </label>
    )
}